import React from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

import SubscriptionEditorView from './SubscriptionEditorView';
import UserView from './UserView';
import UsersTable from '../components/superadmin/UsersTable';

import { useAuth } from '../AuthContext';

import './css/superadmin.css';

// The superadmin page's tabs, each at its own address under /superadmin.
export const c_SuperadminTabSubscriptions = 'subscriptions';
export const c_SuperadminTabUsers = 'users';
const c_SuperadminTabs = [c_SuperadminTabSubscriptions, c_SuperadminTabUsers];

// The superadmin page, superadmin only: the subscription editor in one tab and the users in another. The open tab is
// the address (/superadmin/subscriptions, /superadmin/users), so it survives a reload, and a user opened from the users
// table is /superadmin/users/:user_id, shown in the Users tab in place of the table.
function SuperadminView(){
	const { is_superadmin } = useAuth();
	const navigate = useNavigate();
	const { tab, user_id } = useParams();

	const active_tab = user_id ? c_SuperadminTabUsers : (c_SuperadminTabs.includes(tab) ? tab : c_SuperadminTabSubscriptions);

	if(!is_superadmin){
		return (
			<Container className="view-container superadmin-view">
				<p className="superadmin-empty">This page is for administrators only.</p>
			</Container>
		);
	}

	const render_users_tab = ()=>{
		if(user_id){
			return <UserView user_id={user_id} on_back={()=>{ navigate('/superadmin/' + c_SuperadminTabUsers); }}/>;
		}

		return <UsersTable on_open={(user)=>{ navigate('/superadmin/' + c_SuperadminTabUsers + '/' + user.id); }}/>;
	};

	return (
		<Container className="view-container superadmin-view">
			<h1 className="superadmin-title">SuperAdmin</h1>
			<Tabs
				className="superadmin-tabs"
				activeKey={active_tab}
				onSelect={(key)=>{ navigate('/superadmin/' + key); }}
				mountOnEnter
				unmountOnExit>
				<Tab eventKey={c_SuperadminTabSubscriptions} title="Subscriptions">
					<SubscriptionEditorView embedded={true}/>
				</Tab>
				<Tab eventKey={c_SuperadminTabUsers} title="Users">
					{render_users_tab()}
				</Tab>
			</Tabs>
		</Container>
	);
}

export default SuperadminView;
